import TicketCreateAlerts from './TicketCreateAlerts';

export { TicketCreateAlerts };
export default TicketCreateAlerts;
